<template>
  <div class="container">
    <el-breadcrumb >
      <el-breadcrumb-item :to="Paths.HOMEPAGE">Trang chủ</el-breadcrumb-item>
      <el-breadcrumb-item>Thư mục</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="d-flex flex-column">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <h1 class="heading_one">Quản lý thư mục</h1>
        </el-col>
        <el-col :span="6">
          <TagCreate v-if="hasCreateTagPermission" @success="reload" />
        </el-col>
      </el-row>
      <TagList ref="tagList" />
    </div>
  </div>
</template>

<script>
import TagList from '@/components/TagsManagement/TagList'
import TagCreate from '@/components/TagsManagement/TagCreate'
import { Permission } from '@/constants/DoITConstant'
import { Paths } from '@/routes/paths.js'
import { mapGetters } from 'vuex'
import { AuthenticateGetter } from '@/store/modules/AuthenticateStore'

export default {
  name: 'UserTagManagementView',
  components: { TagList, TagCreate },
  data() {
    return {
      Paths,
    }
  },
  methods: {
    reload() {
      this.$refs.tagList.loadItems()
    },
  },
  computed: {
    ...mapGetters({
      tagPermissions: AuthenticateGetter.TAG_PERMISSIONS,
    }),
    hasCreateTagPermission() {
      return this.tagPermissions != null ? this.tagPermissions.includes(Permission.CREATE) : false
    },
  },
}
</script>

<style scoped></style>
